export const AUTHORIZATION = 'X-AUTH-TOKEN'
export const API_SERVER = 'https://quizapp-api.websa.tech'
// export const API_SERVER = 'http://localhost:8989'
export const BASE_URL = '/api/v1/'



// WEBPACK FOOTER //
// ./src/constants/constants.js